import { useMemo } from 'react';
import constant from '../../../../constants/constant';

export const useRejectedReferralStyles = (referralCaseload: any) => {
  const isRejected = useMemo(() => {
    return referralCaseload?.status === constant.ACTIVE_REFERRAL_STATUS.REJECTED;
  }, [referralCaseload?.status]);

  const rejectedStyles = useMemo(() => ({
    color: isRejected ? '#dadada' : '#6A2382',
    pointerEvents: isRejected ? 'none' : 'auto',
  }), [isRejected]);

  return { isRejected, rejectedStyles };
};
